import { ILanding } from 'models/landings.model'
import { IAppState } from 'models/store.models'

export const selectLandings = (state: IAppState): ILanding[] =>
  state.landings.landings
export const selectLandingsCount = (state: IAppState): number =>
  state.landings.landingsCount
export const selectLandingsSearchString = (state: IAppState): string =>
  state.landings.searchString
